import { z } from 'zod';

export const loginSchema = z.object({
  name: z
    .string()
    .min(5, 'Username should be at least 5 characters long')
    .max(32, {
        error: 'Username must be at most 32 characters'
    }),
  email: z.email('Invalid email address'),
  password: z.string().min(8, 'Offline password is at least 8 characters long'),
});

export type LoginFormData = z.infer<typeof loginSchema>;
